/**
 * Pinia Store Initialization
 */
import { createPinia } from 'pinia'

export const pinia = createPinia()

// Re-export stores
export * from './auth.store'
export * from './contacts.store'
export * from './companies.store'
export * from './deals.store'
export * from './projects.store'
export * from './tasks.store'
export * from './time-entries.store'
export * from './proposals.store'
export * from './invoices.store'
export * from './activities.store'
export * from './users.store'
export * from './ui.store'
export * from './client-portal.store'
export * from './admin.store'
export * from './email-campaigns.store'
export * from './branding.store'
export * from './pipeline.store'
export * from './notifications.store'
export * from './workspace.store'
export * from './custom-fields.store'
export * from './impersonation.store'
export * from './referrals.store'
export * from './contracts.store'
